export default "__VITE_ASSET__HT2tQbvm__"